export default __webpack_public_path__ + "static/media/fastclix_lancets.bb7d1b30.png";